import { c as _c } from "react/compiler-runtime";
import { getRandomObjectId } from "@/helpers/AllowlistToolHelpers";
import CommonCardSkeleton from "@/components/utils/animation/CommonCardSkeleton";
import CommonSkeletonLoader from "@/components/utils/animation/CommonSkeletonLoader";
export default function UserPageCollectedFirstLoading() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="tw-w-full"><CommonSkeletonLoader /><CommonSkeletonLoader /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="tw-w-full">{t0}<div className="tw-mt-6 lg:tw-mt-8"><div className="tw-flow-root"><div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 md:tw-grid-cols-3 xl:tw-grid-cols-4 2xl:tw-grid-cols-5 3xl:tw-grid-cols-6 tw-gap-6 tw-pb-2">{Array.from({
              length: 20
            }).map(_temp)}</div></div></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function _temp() {
  return <div key={`user-page-skeleton-${getRandomObjectId()}`} className="tw-w-full tw-pt-8 tw-h-96"><CommonCardSkeleton /></div>;
}